import * as actions from './slice'

const authorList = {
  eventName: 'authorList',
  onSuccess: [{ action: actions.setAuthors, redux: true }]
}

const authorGet = {
  eventName: 'authorGet',
  onSuccess: [{ action: actions.setAuthor, redux: true }]
}

const authorGetContents = {
  eventName: 'authorGetContents',
  onSuccess: [{ action: actions.setAuthorContents, redux: true }]
}

export { authorList, authorGet, authorGetContents }
